import { ILabelOption } from '../constants/interfaces';

// Update formState type to support value and children
export interface IFormStateValue {
  value: string | number | boolean;
  children?: unknown[];
}

/**
 * Gets the initial/default value for a form field
 * Checks if field has options with isDefault=true and returns that option's text
 * @param field - The field configuration
 * @returns The default value (option text) or empty string
 */
export function getFieldDefaultValue(field: {
  options?: Array<{ isDefault: boolean; text: string }>;
}): string {
  if (field.options && field.options.length > 0) {
    const defaultOption = field.options.find(
      (option) => option.isDefault === true
    );
    if (defaultOption) {
      return defaultOption.text;
    }
  }
  return '';
}

export const getOptions = (
  options: ILabelOption[],
  formState: Record<string, IFormStateValue>
) => {
  return options
    .filter(
      (o) =>
        o.parentLabelId === 0 ||
        (o.parentLabelId !== 0 &&
          o.parentResponseValue === formState[o.parentLabelId]?.value)
    )
    .map((o) => o);
};
